import { Component, OnInit } from '@angular/core';

import { FormsService } from '../forms.service';
import {FormMasterItemConfigurationModel} from '../../../models/forms/form-master-item-configuration.model';
import {FormItemConfigurationModel} from '../../../models/forms/form-item-configuration.model';
import {FormParagraphConfigurationModel} from '../../../models/forms/form-paragraph-configuration.model';
import {FormVersionConfigurationModel} from '../../../models/forms/form-version-configuration.model';
import {FormConfigurationModel} from '../../../models/forms/form-configuration.model';

@Component({
  selector: 'app-forms-builder',
  templateUrl: './forms-builder.component.html',
  styleUrls: ['./forms-builder.component.css']
})
export class FormsBuilderComponent implements OnInit {

  saveMode: string = 'create';
  fetchFromDatabase: boolean = false;
  isLoading: boolean = true;
  cfgForm: FormConfigurationModel;
  cfgFormVersion: any;
  masterItems: FormMasterItemConfigurationModel[] = [];
  newGuids: string[] = [];
  formJSON: string = '';

  expandedRowsObjs: any[] = [];

  formItemControlIds: any[] = [
    { id: null, display: 'NONE' },
    { id: "00000001-1000-0000-0000-000000000001", display: "TEXT_BOX" },
    { id: "00000001-1000-0000-0000-000000000002", display: "HEADING" },
    { id: "00000001-1000-0000-0000-000000000003", display: "GROUP_HEADING_WITH_SUMMARY" },
    { id: "00000001-1000-0000-0000-000000000004", display: "RADIO_LIST" },
    { id: "00000001-1000-0000-0000-000000000005", display: "CHECK_BOX_LIST" },
    { id: "00000001-1000-0000-0000-000000000006", display: "LABEL" },
    { id: "00000001-1000-0000-0000-000000000007", display: "CHECK_BOX" },
    { id: "00000001-1000-0000-0000-000000000008", display: "NUMERIC_SLIDER" },
    { id: "00000001-1000-0000-0000-000000000009", display: "NUMERIC_INTEGER" },
    { id: "00000001-1000-0000-0000-000000000010", display: "NUMERIC_DECIMAL" },
    { id: "00000001-1000-0000-0000-000000000011", display: "DATE" },
    { id: "00000001-1000-0000-0000-000000000012", display: "TIME" },
    { id: "00000001-1000-0000-0000-000000000013", display: "DATE_TIME" },
    { id: "00000001-1000-0000-0000-000000000014", display: "COMBO_LIST" },
    { id: "00000001-1000-0000-0000-000000000015", display: "CURRENCY" },
    { id: "00000001-1000-0000-0000-000000000016", display: "AUTOFILL_FORM" },
    { id: "00000001-1000-0000-0000-000000000017", display: "BLOOD_PRESSURE" },
    { id: "00000001-1000-0000-0000-000000000018", display: "LABEL_45" },
    { id: "00000001-1000-0000-0000-000000000019", display: "TOOTH_PICKER" },
    { id: "00000001-1000-0000-0000-000000000020", display: "ACTION_BUTTON" },
    { id: "00000001-1000-0000-0000-000000000021", display: "ROW_HEADER" },
    { id: "00000001-1000-0000-0000-000000000022", display: "SMALL_CHECK_BOX" },
    { id: "00000001-1000-0000-0000-000000000023", display: "NUMERIC_DRAG_INPUT_SLIDER" },
    { id: "00000001-1000-0000-0000-000000000024", display: "VITAL_SIGNS" },
    { id: "00000001-1000-0000-0000-000000000025", display: "TEXT_AREA" },
    { id: "00000001-1000-0000-0000-000000000026", display: "SPACER" },
    { id: "00000001-1000-0000-0000-000000000027", display: "SIGNATURE" }
  ];

  enumLabelAligmentIds: any[] = [
    { id: null, display: 'NONE' },
    { id: '00000036-1000-0000-0000-000000000001', display: 'Left' },
    { id: '00000036-1000-0000-0000-000000000002', display: 'Right' },
    { id: '00000036-1000-0000-0000-000000000003', display: 'Center' }
  ];

  enumFormCategoryIds: any[] = [
    { id: null, display: 'NONE' },
    { id: '00000014-1000-0000-0000-000000000001', display: 'General' },
    { id: '00000014-1000-0000-0000-000000000002', display: 'Endo' },
    { id: '00000014-1000-0000-0000-000000000003', display: 'Perio' }
  ];

  enumFormDataSourceIds: any[] = [
    { id: null, display: 'NONE' },
    { id: '00000030-1000-0000-0000-000000000001', display: 'Generic Form Data Source' },
    { id: '00000030-1000-0000-0000-000000000002', display: 'Custom Form' }
  ];

  enumCustomFormIds: any[] = [
    { id: null, display: 'NONE' },
    { id: '00000039-1000-0000-0000-000000000001', display: 'Perio Chart' },
    { id: '00000039-1000-0000-0000-000000000002', display: 'Treatment Chart' }
  ];

  enumDFormBuildStatusIds: any[] = [
    { id: null, display: 'NONE' },
    { id: '00000021-1000-0000-0000-000000000001', display: 'Draft' },
    { id: '00000021-1000-0000-0000-000000000002', display: 'Ready for review' },
    { id: '00000021-1000-0000-0000-000000000003', display: 'In Review' },
    { id: '00000021-1000-0000-0000-000000000004', display: 'Approved' },
  ];

  enumParagraphOrientationIds: any[] = [
    { id: null, display: 'NONE' },
    { id: '00000020-1000-0000-0000-000000000001', display: 'Horizontal' },
    { id: '00000020-1000-0000-0000-000000000002', display: 'Vertical' }
  ];

  enumItemLayoutIds: any[] = [
    { id: null, display: 'NONE' },
    { id: '0000001F-1000-0000-0000-000000000001', display: 'Side By Side' },
    { id: '0000001F-1000-0000-0000-000000000002', display: 'Two Line' }
  ];

  constructor(
    private formsService: FormsService
  ) {
    console.log('Forms Build constructed');
  }

  isRowToggled(paragraphIndex, rowIndex) {
    let term = `${paragraphIndex}|${rowIndex}`;
    return (this.expandedRowsObjs.indexOf(term) > -1);
  }

  toggleExpandedRow(paragraphIndex, rowIndex) {

    console.log('HERE');
    console.log(this.expandedRowsObjs);

    let term = `${paragraphIndex}|${rowIndex}`;

    if (this.expandedRowsObjs.indexOf(term) > -1) {
      this.expandedRowsObjs.splice(this.expandedRowsObjs.indexOf(term), 1);
    } else {
      this.expandedRowsObjs.push(term);
    }
    console.log(this.expandedRowsObjs);
    console.log('-------------');
  }


  ngOnInit() {
    this.fetchNewGuids()
      .then((result: string[]) => {
        this.newGuids = result;

        if (this.fetchFromDatabase) {
          this.fetchAndInitCfgForm();
        } else {
          this.initNewCfgForm();
          this.generateFormJSON();
          this.toggleParagraphIsExpanded(this.cfgFormVersion.cfgDFormParagraphs);
          this.isLoading = false;
        }
      }, err => {
        console.log('ERROR GETTING NEW GUIDS', err);
      });
  }

  async saveData() {

    this.convertUIToModelFormat();
    this.setMasterItemNames();

    let saveCfgFormResult = <Boolean>await this.saveCfgForm(this.cfgForm);

    if (saveCfgFormResult) {
      let saveVersionResult = <Boolean>await this.saveCfgFormVersions(this.cfgForm.cfgDFormVersions);

      if (saveVersionResult) {

        for (let i = 0; i < this.cfgForm.cfgDFormVersions.length; i++) {
          let version = this.cfgForm.cfgDFormVersions[i];
          let paragraphs = version.cfgDFormParagraphs;
          let saveParagraphsResult = <Boolean>await this.saveParagraphs(paragraphs);
          if (!saveParagraphsResult) {
            console.log("ERROR SAVING PARAGRAPHS");
            return;
          }
        }

        let saveMasterItemResult = <Boolean>await this.saveMasterItems(this.masterItems);
        if (!saveMasterItemResult) {
          console.log("ERROR SAVING MASTER ITEMS");
          return;
        }

        for (let i = 0; i < this.cfgForm.cfgDFormVersions.length; i++) {
          let version = this.cfgForm.cfgDFormVersions[i];
          for (let j = 0; j < version.cfgDFormParagraphs.length; j++) {
            let paragraph = version.cfgDFormParagraphs[j];
            let items = paragraph.cfgDFormItems;
            let saveItemsResult = <Boolean>await this.saveItems(items);
            if (!saveItemsResult) {
              console.log('ERROR SAVING ITEMS');
              return;
            }
          }
        }

        console.log("DONE!");

      } else {
        console.log('ERROR SAVING VERSION');
      }

    } else {
      console.log('ERROR SAVING CFGFORM');
    }
  }

  saveCfgForm(cfgForm) {
    let cfgFormClone = JSON.parse(JSON.stringify(cfgForm));
    cfgFormClone.cfgDFormVersions = [];
    cfgFormClone.enumFormCategory = null;
    cfgFormClone.enumFormDataSource = null;
    cfgFormClone.enumCustomForm = null;
    let promise = new Promise((resolve, reject) => {

      this.formsService.saveCfgForm(cfgFormClone, this.saveMode)
        .subscribe(response => {
          resolve('1');
        }, err => {
          resolve('1');
        });

    });
    return promise;
  }

  saveCfgFormVersions(cfgVersions: any[]) {
    let promise = new Promise((resolve, reject) => {

      let promises = [];
      cfgVersions.forEach(version => {
        let versionClone = JSON.parse(JSON.stringify(version));
        versionClone.cfgDFormParagraphs = [];
        versionClone.enumDFormBuildStatus = null;
        promises.push(this.saveSingVersion(versionClone));
      });

      Promise.all(promises).then(results => {
        if (results.indexOf('-1') > -1) {
          console.log('resolving false...', results);
          resolve(false);
        } else {
          resolve(true);
        }
      }, err => {
        resolve(false);
      });

    });
    return promise;
  }

  saveSingVersion(cfgVersion) {
    let promise = new Promise((resolve, reject) => {
      this.formsService.saveCfgFormVersion(cfgVersion, this.saveMode)
        .subscribe(response => {
          resolve('1');
        }, err => {
          resolve('1');
        });
    });
    return promise;
  }

  saveParagraphs(cfgParagraphs: any[]) {
    let promise = new Promise((resolve, reject) => {

      let promises = [];

      cfgParagraphs.forEach(paragraph => {
        let paragraphClone = JSON.parse(JSON.stringify(paragraph));
        paragraphClone.cfgDFormItems = [];
        paragraphClone.RepeatDFormItem = null;
        paragraphClone.enumParagraphOrientation = null;
        paragraphClone.enumItemLayout = null;
        promises.push(this.saveSingleParagraph(paragraphClone));
      });

      Promise.all(promises).then(results => {
        if (results.indexOf('-1') > -1) {
          resolve(false);
        } else {
          resolve(true);
        }
      }, err => {
        resolve(false);
      });

    });
    return promise;
  }

  saveSingleParagraph(cfgParagraph) {
    let promise = new Promise((resolve, reject) => {
      this.formsService.saveCfgParagraph(cfgParagraph, this.saveMode)
        .subscribe(response => {
          resolve('1');
        }, err => {
          resolve('1');
        });
    });
    return promise;
  }

  saveMasterItems(cfgMasterItems: any[]) {
    let promise = new Promise((resolve, reject) => {

      let promises = [];

      cfgMasterItems.forEach(item => {
        let itemClone = JSON.parse(JSON.stringify(item));
        promises.push(this.saveSingleMasterItem(itemClone));
      });

      Promise.all(promises).then(results => {
        if (results.indexOf('-1') > -1) {
          resolve(false);
        } else {
          resolve(true);
        }
      }, err => {
        resolve(false);
      });

    });
    return promise;
  }

  saveSingleMasterItem(cfgMasterItem) {
    let promise = new Promise((resolve, reject) => {
      this.formsService.saveCfgMasterItem(cfgMasterItem, this.saveMode)
        .subscribe(response => {
          resolve('1');
        }, err => {
          resolve('1');
        });
    });
    return promise;
  }

  saveItems(cfgItems: any[]) {
    let promise = new Promise((resolve, reject) => {

      let promises = [];

      cfgItems.forEach(item => {
        let itemClone = JSON.parse(JSON.stringify(item));
        itemClone.cfgDFormMasterItem = null;
        itemClone.Calculation = null;
        itemClone.BeforeDisplayItemAction = null;
        itemClone.AfterUpdateItemAction = null;
        itemClone.ValidValue = null;
        itemClone.cfgDFormMasterItem = null;
        itemClone.enumFormControl = null;
        itemClone.enumLabelAligment = null;
        itemClone.enumValidValueItem4Forms = null;
        itemClone.ChildDFormItems = [];
        promises.push(this.saveSingleItem(itemClone));
      });

      Promise.all(promises).then(results => {
        console.log('ITEM RESULTS', results);
        if (results.indexOf('-1') > -1) {
          resolve(false);
        } else {
          resolve(true);
        }
      }, err => {
        resolve(false);
      });

    });
    return promise;
  }

  saveSingleItem(cfgItem) {
    let promise = new Promise((resolve, reject) => {
      this.formsService.saveCfgItem(cfgItem, this.saveMode)
        .subscribe(response => {
          resolve('1');
        }, err => {
          resolve('1');
        });
    });
    return promise;
  }

  setMasterItemNames() {
    let count = Math.random() % 1000 + 1;
    this.cfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      paragraph.cfgDFormItems.forEach(item => {
        this.masterItems.forEach(masterItem => {
          if (item.DFormMasterItemId === masterItem.DFormMasterItemId) {
            masterItem.DFormItemName = item.DFormItemName + `${count}`;
            count++;
          }
        });
      });
    });
  }

  fetchAndInitCfgForm() {
    let formId = '32be2622-f7ba-4e15-8d75-6057436e4d58';
    let versionIndex = 0;

    let promise = new Promise((resolve, reject) => {
      this.formsService.getCfgDForm(formId)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });

    promise.then((result: FormConfigurationModel) => {
      this.cfgForm = result;
      this.cfgFormVersion = result.cfgDFormVersions[versionIndex];
      this.convertModelToUIFormat();
      this.generateFormJSON();
      this.toggleParagraphIsExpanded(this.cfgFormVersion.cfgDFormParagraphs);
      this.isLoading = false;
    });

  }

  initParagraphsIsExpanded(paragraphs: any[]) {
    paragraphs.forEach(paragraph => {
      paragraph.isExpanded = false;
    });
  }

  toggleParagraphIsExpanded(paragraph: any) {
    paragraph.isExpanded = !paragraph.isExpanded;
  }

  initNewCfgForm() {
    this.cfgForm = this.createNewCfgForm();
    this.cfgFormVersion = this.createNewCfgFormVersion(this.cfgForm.DFormId);
    this.cfgForm.cfgDFormVersions.push(this.cfgFormVersion);
  }

  createNewCfgForm(): any {
    let cfgForm = new FormConfigurationModel();
    cfgForm.cfgDFormVersions = [];
    cfgForm.DFormId = this.getNewGuid();
    cfgForm.DFormName = '';
    cfgForm.TDOCID = 0;
    cfgForm.enumCustomFormID = '';
    cfgForm.enumFormCategoryID = '';
    cfgForm.enumFormDataSourceID = '';
    cfgForm.xauditDeleted = false;
    cfgForm.xauditTableRowID = this.getNewGuid();
    cfgForm.xauditModifiedOn = new Date();
    cfgForm.xauditCreatedOn = new Date();
    return cfgForm;
  }

  createNewCfgFormVersion(dFormId: string): any {
    let formVersion = new FormVersionConfigurationModel();
    formVersion.cfgDFormParagraphs = [];
    formVersion.DFormBuildStatusBy = '';
    formVersion.DFormVersionId = this.getNewGuid();
    formVersion.DFormId = dFormId;
    formVersion.Revision = 1;
    formVersion.enumDFormBuildStatusID = '';
    formVersion.DFormBuildStatusOn = new Date();
    formVersion.xauditModifiedOn = new Date();
    formVersion.xauditCreatedOn = new Date();
    formVersion.xauditDeleted = false;
    formVersion.xauditTableRowID = this.getNewGuid();
    return formVersion;
  }

  createNewCfgDFormParagraph(paragraphOrder: number, DFormVersionId: string): any {
    let newParagraph = new FormParagraphConfigurationModel();
    newParagraph.cfgDFormItems = [];
    newParagraph.DFormParagraphId = this.getNewGuid();
    newParagraph.DFormVersionId = DFormVersionId;
    newParagraph.ParagraphName = '';
    newParagraph.isRepeting = false;
    newParagraph.isFillForward = false;
    newParagraph.RepeatDFormItemId = '';
    newParagraph.enumParagraphOrientationID = '';
    newParagraph.MaximumColumnCount = 0;
    newParagraph.MaximumRowCount = 0;
    newParagraph.ParagraphIndent = 0;
    newParagraph.enumItemLayoutID = '';
    newParagraph.isFirstRowHeader = false;
    newParagraph.HeaderHeight = 0;
    newParagraph.ParagraphOrder = paragraphOrder;
    newParagraph.PageBreakAfter = false;
    newParagraph.xauditDeleted = false;
    newParagraph.xauditTableRowID = this.getNewGuid();
    newParagraph.xauditModifiedOn = new Date();
    newParagraph.xauditCreatedOn = new Date();
    return newParagraph;
  }

  createNewCfgDFormMasterItem(): any {
    let newMasterItem = new FormMasterItemConfigurationModel();
    newMasterItem.DFormMasterItemId = this.getNewGuid();
    newMasterItem.TDOCID = 0;
    newMasterItem.DFormItemName = '';
    newMasterItem.enumFormControlID = '';
    newMasterItem.Label = '';
    newMasterItem.xauditDeleted = false;
    newMasterItem.xauditTableRowID = this.getNewGuid();
    newMasterItem.xauditModifiedOn = new Date();
    newMasterItem.xauditCreatedOn = new Date();
    return newMasterItem;
  }

  createNewCfgDFormItem(itemOrder: number, paragraphId: string, masterItemGuid: string): any {
    let newItem = new FormItemConfigurationModel();
    newItem.DFormItemId = this.getNewGuid();
    newItem.DFormParagraphId = paragraphId;
    newItem.DFormItemName = '';
    newItem.DFormMasterItemId = masterItemGuid;
    newItem.ParentDFormItemId = '';
    newItem.HasChildren = false;
    newItem.enumFormControlID = '';
    newItem.ItemOrder = itemOrder;
    newItem.ParagraphRow = 0;
    newItem.ParagraphColumn = 0;
    newItem.ParagraphRowHeight = 0;
    newItem.ParagraphColumnWidth = 0;
    newItem.FormControlColumnSpan = 0;
    newItem.Label = '';
    newItem.LabelWidth = 0;
    newItem.PostLabel = '';
    newItem.ValidValueId = '';
    newItem.BeforeDisplay_ItemActionId = '';
    newItem.AfterUpdate_ItemActionId = '';
    newItem.DefaultValue = '';
    newItem.isBreakAfterItem = false;
    newItem.CalculationID = '';
    newItem.isNoteEnabled = false;
    newItem.isDocumentEnabled = false;
    newItem.enumLabelAligmentID = '';
    newItem.enumPostLabelAligmentID = '';
    newItem.xauditDeleted = false;
    newItem.xauditTableRowID = this.getNewGuid();
    newItem.xauditModifiedOn = new Date();
    newItem.xauditCreatedOn = new Date();
    return newItem;
  }

  getNewGuid() {
    return this.newGuids.pop();
  }

  fetchNewGuids() {
    let promise = new Promise((resolve, reject) => {
      this.formsService.getNewFormGuids()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  generateFormJSON() {
    this.convertUIToModelFormat();
    let objs = {
      cfgForm: this.cfgForm,
      masterItems: this.masterItems
    };
    this.formJSON = JSON.stringify(objs);
  }

  loadFromJSON() {
    let obj = JSON.parse(this.formJSON);
    let cfgForm = obj.cfgForm;
    this.cfgForm = cfgForm;
    this.cfgFormVersion = this.cfgForm.cfgDFormVersions[0];
    this.masterItems = obj.masterItems;
    this.convertModelToUIFormat();
  }

  addParagraphToVersion() {
    let order = 0;
    this.cfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      if (paragraph.ParagraphOrder >= order) {
        order = paragraph.ParagraphOrder + 1;
      }
    });
    let paragraph = this.createNewCfgDFormParagraph(order, this.cfgFormVersion.DFormVersionId);
    paragraph.ROWS = [];
    this.cfgFormVersion.cfgDFormParagraphs.push(paragraph);
    this.orderParagraphs();
    this.convertModelToUIFormat();
  }

  addRowToParagraph(paragraph) {
    paragraph.ROWS.push([]);
  }

  addItemToRow(paragraph, row, rowIndex) {
    let masterItem = this.createNewCfgDFormMasterItem();
    this.masterItems.push(masterItem);
    let order = row.length;
    let item = this.createNewCfgDFormItem(order, paragraph.DFormParagraphId, masterItem.DFormMasterItemId);
    item.ParagraphRow = rowIndex;
    item.ParagraphColumn = row.length;
    row.push(item);
  }

  orderParagraphs() {
    this.cfgFormVersion.cfgDFormParagraphs = this.cfgFormVersion.cfgDFormParagraphs.sort((a, b) => {
      return a.ParagraphOrder - b.ParagraphOrder;
    });
    let paragraphOrder = 0;
    this.cfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      paragraph.ParagraphOrder = paragraphOrder;
      paragraphOrder++;
    });
  }

  removeItemFromRow(row, item, index) {
    console.log('master items before', this.masterItems);
    console.log('item being removed', item);
    this.masterItems = this.masterItems.filter(masterItem => {
      return masterItem.DFormMasterItemId != item.DFormMasterItemId;
    });
    console.log('master items after', this.masterItems);
    row.splice(index, 1);
    this.reOrderRow(row);
  }

  reOrderRow(row) {
    let columnCount = 0;
    row = row.sort((a, b) => {
      return a.ParagraphColumn - b.ParagraphColumn;
    });

    row.forEach(item => {
      item.ParagraphColumn = columnCount;
      columnCount++;
    });
  }

  reOrderRowsAndItems(paragraph) {
    let items = [];

    paragraph.ROWS.forEach(row => {
      items = items.concat(row);
    });

    console.log('Paragraph Items', items);

    let paragraphRows = {};
    items.forEach(item => {
      if (!paragraphRows[item.ParagraphRow]) {
        paragraphRows[item.ParagraphRow] = [];
      }
      paragraphRows[item.ParagraphRow].push(item);
    });

    console.log('PARAGRAPH ROWS', paragraphRows);

    for (var i in paragraphRows) {
      paragraphRows[i] = paragraphRows[i].sort((a, b) => {
        return a.ParagraphColumn - b.ParagraphColumn;
      });
    }

    let newRows = [];
    for (var i in paragraphRows) {
      newRows.push(paragraphRows[i]);
    }

    newRows.forEach(row => {
      this.reOrderRow(row);
    });

    paragraph.ROWS = newRows;
  }

  addItemToParagraph(paragraph: any) {
    let order = 0;
    paragraph.cfgDFormItems.forEach(item => {
      if (item.ItemOrder >= order) {
        order = item.ItemOrder + 1;
      }
    });

    let masterItem = this.createNewCfgDFormMasterItem();
    this.masterItems.push(masterItem);
    let item = this.createNewCfgDFormItem(order, paragraph.DFormParagraphId, masterItem.DFormMasterItemId);
    item.cfgDFormMasterItem = masterItem;
    paragraph.cfgDFormItems.push(item);
    this.orderItems(paragraph);
    this.convertModelToUIFormat();
  }

  orderItems(paragraph: any) {
    paragraph.cfgDFormItems = paragraph.cfgDFormItems.sort((a, b) => {
      return a.ItemOrder - b.ItemOrder;
    });
  }

  orderEverything() {
    this.orderParagraphs();
    this.cfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      this.orderItems(paragraph);
    });
  }

  removeParagraph(index) {
    this.cfgFormVersion.cfgDFormParagraphs.splice(index, 1);
    this.orderParagraphs();
  }

  convertModelToUIFormat() {
    this.cfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {

      let paragraphRows = {};

      paragraph.cfgDFormItems.forEach(item => {
        if (!paragraphRows[item.ParagraphRow]) {
          paragraphRows[item.ParagraphRow] = [];
        }
        paragraphRows[item.ParagraphRow].push(item);
      });

      for (var i in paragraphRows) {
        paragraphRows[i] = paragraphRows[i].sort((a, b) => {
          return a.ParagraphColumn - b.ParagraphColumn;
        });
      }

      console.log('paragraphRows', paragraphRows);

      let rowArr = [];
      for (let i in paragraphRows) {
        rowArr = rowArr.concat([paragraphRows[i]]);
      }
      paragraph.ROWS = rowArr;
      console.log('P ROWS!', paragraph.ROWS);
    });
  }

  convertUIToModelFormat() {
    this.cfgFormVersion.cfgDFormParagraphs.forEach(paragraph => {
      paragraph.cfgDFormItems = [];
      paragraph.ROWS.forEach(row => {
        paragraph.cfgDFormItems = paragraph.cfgDFormItems.concat(row);
      });
    });
  }
}
